import React from "react";
import { createColumnHelper } from "@tanstack/react-table";
import { ReactComponent as ViewIcon } from "images/view.svg";
import { ReactComponent as EditIcon } from "images/edit_blue.svg";
import { ReactComponent as CopyIcon } from "images/copy.svg";
import { ReactComponent as MoveIcon } from "images/arrow_right.svg";
import { ReactComponent as DeleteIcon } from "images/trash.svg";


const columnHelper = createColumnHelper<any>();

export const getLanesByDay = (
  handleEdit: (planId: string, type: string, turnNumber?: number) => void,
  carrierData?: {
    carrierName: string;
    carrierNumber: string;
  }[]) => [
    columnHelper.accessor("id", {
      header: "Plan ID",
      size: 90,
      cell: info => info.getValue(),
    }),

    columnHelper.accessor("manifestNumber", {
      header: "Manifest",
      size: 110,
      cell: info => info.getValue() ? <div>{info.getValue()}</div> : '-',
    }),

    columnHelper.accessor("turnNumber", {
      header: "Lane Number",
      size: 130,
      cell: info => info.getValue() ? <div>{info.getValue()}</div> : '-',
    }),

    columnHelper.accessor("turnDescription", {
      header: "Description",
      size: 200,
      cell: info => info.getValue() ? <div>{info.getValue()}</div> : '-',
    }),


    columnHelper.accessor("carrierNumber", {
      header: "Carrier",
      size: 140,
      cell: info => {
        const value = info.getValue();

        if (!value) return "-";

        const carrier = carrierData?.find(
          c => c.carrierNumber?.toString() === value.toString()
        );

        return (
          <div>
            {carrier?.carrierName
              ? <span>{carrier.carrierName} - <span className="carrier-number">{value}</span></span>
              : value}
          </div>
        );
      }
    }),


    columnHelper.accessor("dropCount", {
      header: "Drops",
      size: 100,
    }),

    columnHelper.accessor("action", {
      header: "Action",
      size: 130,
      cell: info => <div style={{ display: 'flex', gap: '8px' }}>
        <div title="View" onClick={() => handleEdit(info.row.original.id, "view")}><ViewIcon className="clone-week-btn__icon" /></div>
        <div title="Edit" onClick={() => handleEdit(info.row.original.id, "edit")}><EditIcon className="clone-week-btn__icon" /></div>
        {info.row.original.manifestNumber === null && <div title="Copy" onClick={() => handleEdit(info.row.original.id, "copy", info.row.original.turnNumber)}><CopyIcon className="clone-week-btn__icon" /></div>}
        {info.row.original.manifestNumber === null && <div title="Move" onClick={() => handleEdit(info.row.original.id, "move")}><MoveIcon className="clone-week-btn__icon" /></div>}
        <div title="Delete" onClick={() => handleEdit(info.row.original.id, "delete")}><DeleteIcon className="clone-week-btn__delete_icon" /></div>
      </div>
    }),


  ];
